import { z } from 'zod';
import { contentIdSchema } from '../rules/content-id.js';
/**
 * Выбор, который запись контента объявляет о себе сама.
 *
 * Смысл в том, что визард создания персонажа не знает ни про воина,
 * ни про эльфа: он показывает то, что записи объявили. «Воин выбирает
 * два навыка из девяти» — это поле записи класса, а не список в коде.
 * Добавили класс в `content/srd/` — визард изменился, кода никто
 * не трогал.
 *
 * Формулировка и числа берутся из источника: `name` — подпись строки
 * таблицы, `choose` — число из фразы «Choose 2».
 */
/** Один вариант выбора: что записывается в журнал и что видит человек. */
export const contentOptionSchema = z.strictObject({
    /**
     * Значение выбора: ссылка на запись контента (`srd:athletics`)
     * либо литерал, если варианта отдельной записью в SRD нет
     * («drow» у линии эльфа).
     */
    value: z.union([contentIdSchema, z.string().regex(/^[a-z0-9_]+$/)]),
    /** Подпись из источника, дословно: «Drow», «Animal Handling». */
    label: z.string().min(1),
});
/**
 * Откуда берутся варианты.
 *
 * `list` — источник перечислил их сам (навыки класса, линии эльфа).
 * `catalogue` — источник сказал «любой навык», и список собирается
 * из записей соответствующего типа. Второе важно не меньше первого:
 * иначе «один навык на выбор» пришлось бы переписывать при каждом
 * добавлении навыки.
 */
export const choiceOptionsSchema = z.discriminatedUnion('kind', [
    z.strictObject({
        kind: z.literal('list'),
        options: z.array(contentOptionSchema).min(1),
    }),
    z.strictObject({
        kind: z.literal('catalogue'),
        type: z.enum(['skill', 'language', 'feat', 'spell', 'item']),
    }),
]);
export const contentChoiceSchema = z.strictObject({
    /** Ключ выбора внутри записи: `skills`, `lineage`, `tool`. */
    key: z.string().regex(/^[a-z0-9_]+$/),
    /** Подпись из источника: «Skill Proficiencies», «Elven Lineage». */
    name: z.string().min(1),
    /** Сколько вариантов выбирается. Число из источника, не догадка. */
    choose: z.number().int().positive(),
    from: choiceOptionsSchema,
});
//# sourceMappingURL=choice.js.map